import { merge } from "theme-ui";

export const contentContainer = {
  width: "100%",
  padding: "40px",
  display: "flex",
  flexDirection: "column",
  zIndex: 100,
};

export const modalTitle = {
  textTransform: "uppercase",
  paddingBottom: "20px",
  borderBottom: "solid 4px",
  borderColor: "grey9",
  marginBottom: "20px",
  lineHeight: "30px",
};

export const descriptionText = {
  marginBottom: "20px",
  letterSpacing: "0.05em",
};

export const subText = {
  ...descriptionText,
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "500",
};

export const emailInputContainer = ({ isDesktop }) =>
  merge(
    {
      display: "flex",
      flexDirection: "row",

      width: "100%",
      gap: "20px",
    },

    !isDesktop && {
      flexWrap: "wrap",
      justifyContent: "flex-start",
    }
  );
